import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"

import type { Product, UnitOfMeasurement } from "@/graphql/codegen/graphql"
import { CompanyDefaultUnitOfMeasurement } from "@/graphql/codegen/graphql"
import { isUsUom } from "@/utils/conversion"

const PricingProductWeight: FC<{
  product: Product
  selectedUom: UnitOfMeasurement | undefined
  uoms: UnitOfMeasurement[]
}> = ({ selectedUom, uoms, product }) => {
  const { defaultMeasurementName, standardPackagingWeight, weightPerPallet } = useMemo(() => {
    const displayUsUom = isUsUom(selectedUom?.id ?? "")
    const weightUomId = displayUsUom
      ? CompanyDefaultUnitOfMeasurement.UsstdWeightPound
      : CompanyDefaultUnitOfMeasurement.MetricWeightKilogram

    const defaultMeasurementName = uoms.find(({ id }) => id === weightUomId)?.name
    const weightPerPallet = displayUsUom ? product.palletUsWeight : product.palletMetricWeight
    const standardPackagingWeight = displayUsUom ? product.packageUsWeight : product.packageMetricWeight

    return {
      weightPerPallet,
      standardPackagingWeight,
      defaultMeasurementName,
    }
  }, [
    selectedUom?.id,
    uoms,
    product.palletUsWeight,
    product.palletMetricWeight,
    product.packageUsWeight,
    product.packageMetricWeight,
  ])
  const weight = weightPerPallet || standardPackagingWeight

  if (!weight) {
    return null
  }

  const label = weightPerPallet ? "Weight per Pallet" : "Standard Packaging Weight"

  return (
    <Box>
      <Typography variant='body2' className='whitespace-nowrap text-gray-700'>
        {label} - {weight} {defaultMeasurementName}
      </Typography>
    </Box>
  )
}

export default PricingProductWeight
